import { getOgmaDetectLanguageUri } from './utils/getOgmaUris';
import setOgmaHeaders from './utils/setOgmaHeaders';

export default async function getOgmaDetectedLanguage(
    emailContent: string,
    correlationId: string
): Promise<string> {
    const promise = new Promise<string>(function (resolve, reject) {
        const xhttp = new XMLHttpRequest();

        xhttp.onload = function () {
            if (xhttp.status === 200) {
                const detectedLangauge = JSON.parse(this.responseText);
                if (detectedLangauge) {
                    resolve(detectedLangauge);
                } else {
                    reject('OGMA returned invalid response: ' + this.response);
                }
            } else {
                reject('OGMA failed to detect email language: ' + this.response);
            }
        };

        xhttp.onerror = function () {
            reject('OGMA call failed: ' + this.response);
        };

        xhttp.open('POST', getOgmaDetectLanguageUri());
        const headersAvailable = setOgmaHeaders(xhttp, correlationId);
        if (headersAvailable) {
            xhttp.send(JSON.stringify(emailContent));
        } else {
            reject('getOgmaDetectedLanguage failed: headers were not set. ');
        }
    });

    return promise;
}
